import React, {useState, useEffect, useRef /*, useContext */ } from 'react';
import { Button, Drawer, Form, Input, Select, Divider, Space, message, InputNumber } from 'antd';
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { api } from '../AppConfig';
import * as Setting from '../utils/AuthUtils';
import { useTranslation } from 'react-i18next';

function AddTournamentParticipant(props) {
    const [players, setPlayers] = useState([]);
    const [decknames, setDecknames] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const nameRef = useRef(null);
    const surnameRef = useRef(null);
    const [newplayerName, setNewplayerName] = useState("");
    const [newplayerSurName, setNewplayerSurname] = useState("");
    const [selected, setSelected] = useState([]);
    const [selectedDeck, setSelectedDeck] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const { t } = useTranslation();

    useEffect(() => {
        fetch(api.players().list().href)
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setPlayers(result.payLoad);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              // setError(error);
            }
          )
        fetch(api.decks().archetypesList().href)
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setDecknames(result.payLoad);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              // setError(error);
            }
          )
      }, [])

    function toggleDrawer() {
        // console.warn('arrivato a toggle!!');
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    const onNameChange = (event) => {
        setNewplayerName(event.target.value);
    };
    
    const onSurnameChange = (event) => {
        setNewplayerSurname(event.target.value);
    };

    async function onNewPlayer(e) {
        e.preventDefault()
        // console.warn('nome nuovo giocatore: ', newplayerName, ' ', newplayerSurName);
        if (newplayerName === '' || newplayerSurName === '') {
          messageApi.error('Empty values!! Cannot create a new player!');
          return
        }

        const player = {
          "firstName": newplayerName,
          "lastName": newplayerSurName
        };

        const response = await fetch(api.players().create().href, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(player) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())
        // console.warn('stato di response: ', response);
        if (response.payLoad != null && response.errorMsg == "") {
          messageApi.success(`Player ${response.payLoad.firstName} ${response.payLoad.lastName} created!`);
          setPlayers([...players,response.payLoad])
          setSelected([response.payLoad.id])
        } else {
          messageApi.error(`Error creating player: ${response.errorMsg}!`);
        }
        
    }

    function onFinish(values) {
        values.stageId = props.stageId
        // console.warn('values della form: ', values)
        // console.warn('props: ', props)
        props.onAddPlayer(values.stageId, values)
    }
    
    const playerOpts = players.map((p) => {
        const fullName = p.firstName + ' ' + p.lastName;
        return (<Select.Option key={p.id} value={p.id}>{fullName}</Select.Option>)
    })

    const decknameOpts = decknames.map((d) => {
      return (<Select.Option key={d.id} value={d.name}>{d.name}</Select.Option>)
    })

    return (
        (<div>
            {contextHolder}
            <Button style={{ marginTop: 16 }} type="primary" onClick={toggleDrawer} disabled={!isLoaded} icon={<PlusOutlined />}>
              {t('players.create')}
            </Button>
            <Drawer title={t('players.create')} open={isActive} onClose={toggleDrawer}>
                <Form onFinish={onFinish}>
                    <Form.Item label={t('players.name')} name="playerId">
                        <Select 
                            placeholder={t('players.placeholderName')}
                            value={selected}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                            dropdownRender={(menu) => (
                                <>
                                  {menu}
                                  <Divider
                                    rootstyle={{
                                      margin: '8px 0',
                                    }}
                                  />
                                  <Space
                                    rootstyle={{
                                      padding: '0 8px 4px',
                                    }}
                                  >
                                    <Input
                                      placeholder="Nome"
                                      ref={nameRef}
                                      value={newplayerName}
                                      onChange={onNameChange}
                                      width="45%"
                                    />
                                    <Input
                                      placeholder="Cognome"
                                      ref={surnameRef}
                                      value={newplayerSurName}
                                      onChange={onSurnameChange}
                                      width="45%"
                                    />
                                  </Space>
                                  <Space>
                                  <Button type="text" icon={<PlusOutlined />} onClick={onNewPlayer}>
                                      {t('players.createNew')}
                                    </Button>
                                  </Space>
                                </>
                              )}
                        >
                            {playerOpts}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Rank" name="rankingPlace" >
                      <InputNumber placeholder={t('players.placeholderRanking')} style={{ width: '100%' }}/>
                    </Form.Item>
                    <Form.Item label={t('decks.title')} name="deckName">
                        <Select 
                            placeholder={t('decks.placeholder')}
                            value={selectedDeck}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        >
                            {decknameOpts}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Decklist" name="TxtDeckList" tooltip={{ title: 'Inserire la lista in formato txt, nel seguente modo: <nr copie> <nome carta in inglese>', icon: <InfoCircleOutlined /> }}>
                        <Input.TextArea rows={10} placeholder="Decklist" />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                            Add
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </div>)
    );
}

export default AddTournamentParticipant;